/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const UnitHeight = {
    Centimetres: "centimetres",
    FeetAndInches: "feetAndInches",
};
export function UnitHeightFromJSON(json) {
    return UnitHeightFromJSONTyped(json, false);
}
export function UnitHeightFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function UnitHeightToJSON(value) {
    return value;
}
